import { Link } from "react-router-dom";
import { IonIcon } from "@/components/icons/AppIcon";
import { SUPPORT_EMAIL } from "@/lib/assets";

export default function ContactSection() {
  return (
    <section id="contact" data-testid="contact-section" className="border-t border-[#2C2E29] bg-[#161714] py-24 md:py-32">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-10">
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#CAA362]">Contact en support</p>
        <h2 className="font-serif-display text-3xl font-semibold text-[#EAEBE7] sm:text-4xl">Vragen of hulp nodig?</h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-[#B5B8B0]">
          Heb je een vraag over de app of je account? Stuur ons een e-mail, dan helpen we je verder.
        </p>
        <a
          data-testid="contact-support-email"
          href={`mailto:${SUPPORT_EMAIL}`}
          className="mt-10 inline-flex items-center gap-3 rounded-xl bg-[#CAA362] px-7 py-3.5 text-sm font-semibold text-[#1A1509] transition-colors hover:bg-[#E0BE82]"
        >
          <IonIcon name="mail-outline" size={18} />
          {SUPPORT_EMAIL}
        </a>
        <div className="mt-8">
          <Link
            data-testid="contact-delete-account-link"
            to="/delete-account"
            className="inline-flex items-center gap-2 text-sm text-[#8E9189] transition-colors hover:text-[#E0BE82]"
          >
            Account verwijderen? Zo werkt het
            <IonIcon name="chevron-forward" size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
